<!--
	We wrap everything in a <form> in every web page so we need a separate control
	for searchable input that handles Enter clicks
	because users tend to click Enter and send(submit) a form accidentally
-->
<template>
	<input
		v-model="internalValue"
		type="search"
		onkeydown="return event.key != 'Enter';"
		class="form-control"
		:class="{ 'mia-SearchInput--with-icon': withIcon }"
	>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "SearchInput",
	props: {
		modelValue: {
			type: String,
			required: true,
		},
		withIcon: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["update:modelValue"],
	computed: {
		internalValue: {
			get(): string {
				return this.modelValue;
			},
			set(value: string) {
				this.$emit("update:modelValue", value);
			},
		},
	},
});
</script>
<style lang="scss">
.mia-SearchInput--with-icon {
	background-image: url("@theme/icons/search_icon.svg");
	background-repeat: no-repeat;
	background-position: right theme.$mia-padding-panel-small center;
	padding-right: theme.$mia-icon-size-large + theme.$mia-padding-panel-small;
}
</style>
